const roles = {
  trial: {
    onboarding: 'trial_onboarding',
    dashboard: 'trial_dashboard',
    builder: 'trial_builder',
    experiences: 'trial_experiences',
    profile: 'trial_profile',
    admin: 'trial_admin',
  }
};

export default roles;
